module.exports = __webpack_public_path__ + "static/media/striker.20929192.apk";